import { Grid, Paper, Typography } from "@mui/material";
import styles from "../../styles/proposal/projectDetail.module.css";
import VideoPlayer from "./VideoPlayer";

const ProposalVideo = (props: any) => {
  return (
    <Paper component="div" elevation={4} className={styles.paper}>
      <Typography variant="h5"> Videos </Typography>
      <Grid container spacing={2}>
        {props.videos.map((video: string) => (
          <VideoPlayer url={video} />
        ))}
      </Grid>
    </Paper>
  );
};

export default ProposalVideo;
